import { FormControl, RadioGroup as MuiRadioGroup, type RadioGroupProps as MuiRadioGroupProps } from '@mui/material';
import { type ReactNode, useId } from 'react';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';
import { FormHelperText } from '../../atoms/FormHelperText';
import { FormLabel } from '../../atoms/FormLabel';

type Props = WithoutStyleOverrides<MuiRadioGroupProps> & {
  label?: ReactNode;
  helperText?: ReactNode;
  required?: boolean;
  error?: boolean;
  disabled?: boolean;
};

export function RadioGroup(props: Props) {
  const { label, helperText, required, error, disabled, ...radioGroupProps } = props;
  const labelId = useId();
  const helperId = useId();

  return (
    <FormControl required={required} error={error} disabled={disabled}>
      {label ? <FormLabel id={labelId}>{label}</FormLabel> : null}
      <MuiRadioGroup
        aria-labelledby={label ? labelId : undefined}
        aria-describedby={helperText ? helperId : undefined}
        aria-required={required}
        aria-invalid={error}
        {...radioGroupProps}
      />
      {helperText ? <FormHelperText id={helperId}>{helperText}</FormHelperText> : null}
    </FormControl>
  );
}

export type { Props as RadioGroupProps };
